import { PrimaryButton } from '@chegg/fanta'
import styled from 'styled-components'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import {
  ModalContent as BaseModalContent,
  Container,
  CloseButton as BaseCloseButton,
} from '../styled'

export const ModalContent = styled(BaseModalContent)`
  padding: 32px 0px 0px 0px;
`

export const CloseButton = styled(BaseCloseButton)``

export const TitleIcon = styled.img``

export const TitleText = styled.h2`
  font-size: ${FantaTheme.font.text.size['2xl']};
  font-weight: bold;
  text-align: center;
  margin: 16px 90px;
`

export const ContentContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const CreateAccountButton = styled(PrimaryButton).attrs({ size: 'medium' })`
  padding: 10px 51px;
  margin: 16px 0px;
`

export const UnstyledButton = styled.button`
  background-color: transparent;
  color: ${FantaTheme.colors.link};
  &:hover {
    text-decoration: underline;
  }
`

export const UnlockLink = styled(UnstyledButton)`
  font-size: ${FantaTheme.font.text.size.lg};
  font-weight: bold;
  margin-top: 0px;
`

export const LoginBanner = styled.div`
  font-size: ${FantaTheme.font.text.size.sm};
  background-color: ${FantaTheme.colors.skyXlight};
  color: ${FantaTheme.colors.dark};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 53px;
  margin-top: 16px;
`

export const LoginLink = styled(UnstyledButton)`
  font-weight: bold;
`
